import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Toast, type ToastRef } from '@humanforce/mango-ui-react';

type Tone = 'positive' | 'critical' | 'caution' | 'neutral';
type Message = { id: number; message: string; tone: Tone; sticky?: boolean };

export const useToast = () => {
  const [toasts, setToasts] = useState<Message[]>([]); const nextId = useRef(0);
  const addToast = useCallback((message: string, tone: Tone = 'positive', options?: { sticky?: boolean }) => { const id = ++nextId.current; setToasts(current => [...current, { id, message, tone, sticky: options?.sticky }]); }, []);
  const removeToast = useCallback((id: number) => setToasts(current => current.filter(t => t.id !== id)), []);
  return useMemo(() => ({ addToast, removeToast, toasts }), [addToast, removeToast, toasts]);
};

export const ToastContainer = ({ toasts, onClose }: { toasts: Message[]; onClose: (id: number) => void }) => {
  const ref = useRef<ToastRef>(null); const shown = useRef(new Set<number>());
  useEffect(() => { toasts.forEach(toast => { if (shown.current.has(toast.id)) return; shown.current.add(toast.id); ref.current?.show({ tone: toast.tone, detail: toast.message, ...(toast.sticky ? { sticky: true } : { life: 3000 }) }); if (!toast.sticky) window.setTimeout(() => onClose(toast.id), 3000); }); }, [onClose, toasts]);
  return <><Toast ref={ref} /><div aria-live="polite" className="sr-only">{toasts.map(t => <div key={t.id} role="status">{t.message}</div>)}</div></>;
};
